import type {AppState, StateSlice} from '@src/stores/types.ts';

export const setAppSlice: StateSlice<AppState> = set => ({
  pathname: '',

  setPathname: (pathname: string) =>
    set(
      state => {
        state.app.pathname = pathname;
      },
      undefined,
      'app/setPathname',
    ),
});
